import { apiRequest } from '@/core';
import { type UpdateUserRolePayload } from '@/slices/user/types';

export const updateUserRoleRequest = async ({
  propertyId,
  user_id,
  role_id,
}: UpdateUserRolePayload) =>
  apiRequest<void>({
    endpoint: `api/user/${propertyId}/role`,
    method: 'PATCH',
    body: { user_id, role_id },
  });
